import { Component } from '@angular/core';

@Component({
  selector: 'mtm-column-view-icon',
  templateUrl: './column-view-icon.component.html',
  styles: [],
  standalone: false,
})
export class ColumnViewIconComponent {}
